import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import ProductForm from './product-form';
import ProductGallery from './product-gallery';
import Icon from '../utils/icon';
import Spinner from '../utils/spinner';
import CartService from '../cart/cart-service';

const QuickView = () => {
  const [quickViewVariantId, setQuickViewVariantId] = useState('');
  const [cartState, setCartState] = useState(CartService.cart);
  const [props, setProps] = useState('');
  const [loading, setLoading] = useState(true);
  const [showContent, setShowContent] = useState(false); // Add state for content visibility
  const inFocusElement = useRef(null)
  const [lastFocusedButton, setLastFocusedButton] = useState('');
  const [tabIndex, setTabindex] = useState(-1);
  const [ariaHidden, setAriaHidden] = useState(true);
  const getQuickViewProductData = async (handle) => {
    const response = await fetch(`/products/${handle}?view=quickview-json`);
    return response.json();
  };

  useEffect(() => {
    const handleQuickViewOpen = async (e) => {
      setTabindex(0);
      setAriaHidden(false);               // expose dialog first
      requestAnimationFrame(() => {       // then move focus
      inFocusElement.current?.focus();
        });
      setLastFocusedButton(e?.detail.clickedButton)
      const { productHandle, currentVariant } = e.detail;
      setQuickViewVariantId(currentVariant);
      setLoading(true);
      setShowContent(false); // Hide content initially
      const openPanel = new CustomEvent('open-panel:quick-view');
      document.dispatchEvent(openPanel);
      getQuickViewProductData(productHandle).then(data => {
        const finalData = data;
        setProps(finalData);
        const newQuickVariantId = data.product.variants.find((v) =>
          v.id.includes(currentVariant)
        );
        const variantUpdatedEvent = new CustomEvent('currentVariantUpdated', {
          detail: {
            currentProductData: finalData.product,
            currentVariant: newQuickVariantId.id,
          }
        });
        document.dispatchEvent(variantUpdatedEvent);
        setTimeout(() => {
          setLoading(false);
          setShowContent(true);
        }, 500)
      });
    };
    document.addEventListener('quick-view-opened', handleQuickViewOpen);

    return () => {
      document.removeEventListener('quick-view-opened', handleQuickViewOpen);
    };
  }, [quickViewVariantId, props]);

  useEffect(() => {
    const listener = () => {
      setCartState(CartService.cart);
    }
    CartService.addListener(listener);
    setCartState(CartService.cart);
    return () => {
      CartService.removeListener(listener);
    }
  }, []);

  const closePanel = () => {
    const closeP = new CustomEvent('close-panel:quick-view');

    lastFocusedButton?.focus?.();

    setTabindex(-1)
    setAriaHidden(true)

    document.dispatchEvent(closeP);

  };
  const backFocusHandle = (focusedItem, e) => {
    if (e.shiftKey && e.key === 'Tab') {
      e.preventDefault();
      focusedItem.focus();
    } 
};
 
  return (
    <div className='relative sm:h-[calc(100dvh-147px)] h-full pb-10 overflow-y-auto scrollbar-hide' 
    tabIndex={tabIndex} 
    data-product-view 
    aria-hidden={ariaHidden}
    role="dialog"
    aria-modal="true"
    aria-labelledby="quick-view-title"
    >
      <div className='flex justify-between px-5 py-2.5 items-center'>
        <h1 id="quick-view-title" className='utility-1 uppercase'>
          {window.TMW.Strings.quickView.title}
        </h1>
        <button onClick={closePanel} ref={inFocusElement} aria-label='Close Quick view' tabIndex={tabIndex} id='quick-view-close' 
          onKeyDown={(e)=>{backFocusHandle(document.querySelector('#view_full_product'),e)}}>
          <Icon name='close' />
        </button>
      </div>
      {loading ? (
        <div className='flex justify-center items-center py-10 h-full'>
          <Spinner />
        </div>
      ) : null}
      <div style={{ display: showContent ? 'block' : 'none' }} className='flex flex-col gap-5'>
        <ProductGallery {...props} isProductQuickView={true} />
        <div className='px-5'>
          <ProductForm
            {...props}
            product={props.product}
            cartItems={cartState?.items}
            isProductQuickView={true}
            quickViewVariantId={quickViewVariantId}
            quickViewCloseRef={inFocusElement}
          />
        </div>
      </div>
    </div>
  );
};

export default QuickView;
